import type { PaymentMethod, PickupMethod } from "@/mocks/branch/orders";

export interface CartLine {
  productId: string;
  name: string;
  unitPrice: number;
  quantity: number;
}

export interface ToggleOption<T> {
  value: T;
  label: string;
  icon: string;
}

/** أنواع طلبات POS: محلي أو سفري فقط — لا يوجد استلام بالسيارة في الكاشير */
export const ORDER_TYPE_OPTIONS: ToggleOption<PickupMethod>[] = [
  { value: "dine_in", label: "محلي", icon: "ri-restaurant-line" },
  { value: "takeaway", label: "سفري", icon: "ri-shopping-bag-line" },
];

/** وسائل الدفع في POS: إلكتروني عبر جهاز نقاط البيع أو كاش */
export const POS_PAYMENT_OPTIONS: ToggleOption<PaymentMethod>[] = [
  { value: "pos_terminal", label: "إلكتروني (نقاط البيع)", icon: "ri-bank-card-2-line" },
  { value: "cash", label: "كاش (نقدي)", icon: "ri-money-dollar-circle-line" },
];